/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import {getUlazDropdown} from '../../api'
import {Option} from '../../models/Sektor'

// ulazRepromaterijala Props for the component
interface DropdownProps {
    value?: string | number
    initialValue?: string | number
    onChange?: (name: string, value: any) => void
    errors?: string | undefined
    touched?: boolean
    selectName?: string
}

const UlazRepromaterijalaDropdown: React.FC<DropdownProps> = ({
                                                                  value,
                                                                  initialValue,
                                                                  onChange,
                                                                  errors,
                                                                  touched,
                                                                  selectName,
                                                              }) => {
    const [ulazRepromaterijalaDropdown, setUlazRepromaterijalaDropdown] = useState<Array<Option>>([])
    const internalValue = initialValue ?? null

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getUlazDropdown()
                setUlazRepromaterijalaDropdown(mapData(response.data))
            } catch (error) {
                console.error('Error fetching Ulaz Materijala dropdown data:', error)
            }
        }
        fetchData()
    }, [])

    const finalValue = value ?? internalValue

    const mapData = (data) => {
        if (!data) {
            return []
        }
        return data.map((item) => ({label: item.Naziv, value: item.Id.toString()}))
    }

    return (
        <SearchableSelect
            options={ulazRepromaterijalaDropdown}
            value={finalValue?.toString() ?? ''}
            onChange={onChange!}
            name={selectName ?? 'ulazRepromaterijalaDropdown'}
            errors={errors}
            placeholder='Odaberi Ulaz'
            touched={touched}
        />
    )
}

export default UlazRepromaterijalaDropdown
